<template>
  <div class="container-fluid pb-6">
    <transition-group tag="div" name="faqs-swap" mode="out-in">
      <div key="show">
        <div class="row mb-4">
          <div class="col-mlg-12 text-center">
            <h1 class="title mb-1">{{ $t("faqs.content.title") }}</h1>
            <p class="typo-paragraph14 typo-regular typo-lh150 text-light-low text-light-high desc">{{ $t("faqs.content.descLine1") }}</p>
            <p class="typo-paragraph14 typo-regular typo-lh150 text-light-low text-light-high desc">{{ $t("faqs.content.descLine2") }}</p>
          </div>
        </div>
        <div class="row justify-content-center block-list">
          <FaqsBlock :type="'facebook'"></FaqsBlock>
          <FaqsBlock :type="'helpCenter'"></FaqsBlock>
          <FaqsBlock :type="'youtube'"></FaqsBlock>
          <FaqsBlock :type="'liveChat'"></FaqsBlock>
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
import { Api, ApiUrl } from "../../services";
import FaqsBlock from "./Faqs/FaqsBlock";
export default {
  name: "FaqsModal",
  components: {
    FaqsBlock
  },
  data() {
    return {
      list: ["zH8LZ5GaCaU", "lM7cFVKg9e4", "iylVYC7eAjc", "munCDuvdiUo", "AY8hh1rSQdk", "S30VNxrXNgk"],
      videoList: [],
      delayTimer: undefined
    };
  },
  created() {
    for (let i = 0; i < this.list.length; i++) {
      Api.youtube.get(ApiUrl.youtube.video(this.list[i], "AIzaSyAyRAInKTNDmOYwxFsSWDaXgN526IWh-bo")).then(res => {
        this.videoList.push(res.data);
      });
    }
  },
  beforeDestroy() {},
  methods: {}
};
</script>

<style lang="scss" scoped>
.content {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 60%;
}
.title {
  font-family: Inter;
  font-style: normal;
  font-weight: 600;
  font-size: 72px;
  line-height: 87px;
  text-transform: capitalize;
  // white-space: nowrap;
  // color: $mono3;
  // background: -webkit-linear-gradient(#7190FF, #3C67FF);
  background: -webkit-linear-gradient(left, #7190ff, #3c67ff);
  background: -o-linear-gradient(right, #7190ff, #3c67ff);
  background: -moz-linear-gradient(right, #7190ff, #3c67ff);
  background: linear-gradient(to right, #7190ff, #3c67ff);
  background-clip: text;
  -webkit-text-fill-color: transparent;
}
.desc {
  max-width: 715px;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}
.block-list {
  // margin-bottom: 185px;
  @media only screen and (min-width: 1024px) {
  }
  @media only screen and (min-width: 1280px) {
  }
  @media only screen and (min-width: 1440px) {
  }
  .block {
    background: $light1;
    border-radius: $radius;
    max-width: 260px;
    padding: 24px 24px 24px 22px;
    transition: all 0.3s ease;
    &:not(:first-of-type) {
      margin-left: 32px;
    }
    cursor: pointer;
    &-facebook {
      border-left: 2px solid $light1;
      &:hover {
        .block-title {
          color: $mono3;
        }
        border-left: 2px solid $mono3;
      }
    }
    &-help-center {
      border-left: 2px solid $light1;
      &:hover {
        .block-title {
          color: $accent-yellow;
        }
        border-left: 2px solid $accent-yellow;
      }
    }
    &-live-chat {
      border-left: 2px solid $light1;
      &:hover {
        .block-title {
          color: $accent-green;
        }
        border-left: 2px solid $accent-green;
      }
    }

    &-youtube {
      border-left: 2px solid $light1;
      &:hover {
        .block-title {
          color: $accent-red;
        }
        border-left: 2px solid $accent-red;
      }
    }
  }
}
.video-item-list {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  padding-top: 30%;
  padding-bottom: 30%;
  width: 60%;

  .video-item {
    // margin-left: 4px;
    // margin-right: 4px;
    // max-width: 336px;
    // &:not(:first-of-type) {
    //   margin-left: 32px;
    // }
    .iframe-container {
      position: relative;
      padding-bottom: 56.25%;
      iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }
    }
  }
}

@media screen and (min-width: 768px) and (max-width: 1023px) {
  .block-list {
    .block {
      max-width: 160px;
    }
  }
}

@media screen and (max-width: 767px) {
  .title {
    font-style: normal;
    font-weight: 600;
    font-size: 40px;
    line-height: 48px;
    text-align: center;
  }
  .block-list {
    .block {
      .block-title {
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 19px;
      }
      > p {
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 150%;
      }
      padding: 8px 24px;
      max-width: 260px;
      margin-bottom: 16px;
      &:not(:first-of-type) {
        margin-left: 0px;
      }
    }
  }
}

.animated {
  -webkit-animation-duration: 0.6s;
  animation-duration: 0.6s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  -webkit-animation-timing-function: linear;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  -webkit-animation-iteration-count: infinite;
}
@-webkit-keyframes bounce {
  0%,
  100% {
    -webkit-transform: translateY(1px);
  }
  50% {
    -webkit-transform: translateY(-7px);
  }
}
@keyframes bounce {
  0%,
  100% {
    transform: translateY(1px);
  }
  50% {
    transform: translateY(-7px);
  }
}
.bounce {
  -webkit-animation-name: bounce;
  animation-name: bounce;
}
</style>
